import { Controller } from "@hotwired/stimulus"

// apps/index — data-controller="apps--index" on workspace root (apps index page)
export default class extends Controller {
  connect() {
    $(this.element).on("click.appsIndex", ".btn-close-alert", this.closeAlert)
  }

  disconnect() {
    $(this.element).off(".appsIndex")
  }

  closeAlert = (event) => {
    const $button = $(event.currentTarget)
    const cookie = $.cookie("notification-index")
    const indexes = cookie ? cookie.split(/,/) : []
    indexes.push($button.attr("data-id"))
    $.cookie("notification-index", indexes)
    $button.parents(".flash-notification").toggle("fade")
  }
}
